<template>
  <div
    ref="appHeader"
    class="app-header w-100"
  >
    <template v-if="!isDatapeopleAnywhereEditor">
      <PlatformNavbarContainer v-if="$route.query.view !== 'chrome'" />
    </template>
    <AppAlertsProvider />
  </div>
</template>

<script>
import AppAlertsProvider from '@/components/shared/alerts/AppAlertsProvider.vue';
import { mapState, mapActions } from 'pinia';
import PlatformNavbarContainer from '@/components/navbar/PlatformNavbarContainer.vue';
import { useDatapeopleAnywhereEditor } from '@/stores/document/datapeopleAnywhereEditor';
import { useAppBase } from '@/stores/app/base';

export default {
  name: 'AppHeader',
  components: {
    AppAlertsProvider,
    PlatformNavbarContainer,
  },
  computed: {
    ...mapState(useDatapeopleAnywhereEditor, ['isDatapeopleAnywhereEditor']),
  },
  watch: {
    $route() {
      this.view = this.$route.query.view || 'standard';
    },
  },
  mounted() {
    this.setAppHeaderHeight(this.$refs.appHeader?.clientHeight || 117);
  },
  beforeUnmount() {
    this.setAppHeaderHeight(0);
  },
  methods: {
    ...mapActions(useAppBase, ['setAppHeaderHeight']),
  },
};

</script>

<style lang="less" scoped>
  .app-header {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 8;
  }
</style>
